import { render, staticRenderFns } from "./TimedGoodsList.vue?vue&type=template&id=29e06ea8&scoped=true&"
import script from "./TimedGoodsList.vue?vue&type=script&lang=js&"
export * from "./TimedGoodsList.vue?vue&type=script&lang=js&"
import style0 from "./TimedGoodsList.vue?vue&type=style&index=0&id=29e06ea8&scoped=scoped&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29e06ea8",
  null
  
)

export default component.exports